import {ChangeEvent, MouseEvent, useRef, useState} from 'react';

const LinkInput = ({
  error,
  errorMessage,
  label,
  message,
  link,
  placeholder = '',
  onInputLinkChange,
  value,
  right,
  disabled,
  readOnly,
}: {
  error?: boolean;
  errorMessage?: string;
  label?: string;
  message?: string;
  link?: string;
  placeholder?: string;
  onInputLinkChange?: (text: string) => void;
  value: string;
  right?: JSX.Element;
  disabled?: boolean;
  readOnly?: boolean;
}) => {
  const urlInput = useRef<HTMLInputElement>(null);
  const [isFocus, setIsFocus] = useState<boolean>(false);

  const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    onInputLinkChange && onInputLinkChange(e.target.value);
  };

  const onInputBoxClicked = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();
    urlInput.current?.focus();
  };

  return (
    <div className="mb-3">
      {label && (
        <label className="font-display text-dark-navy mb-2 block dark:text-white">{label}</label>
      )}
      {message && <p className="text-dark-grey dark:text-grey text-2xs mb-3">{message}</p>}
      <div
        onClick={onInputBoxClicked}
        className={
          isFocus
            ? 'flex items-center dark:bg-dark-navy px-3 py-3 border border-grey rounded-md'
            : 'flex items-center dark:bg-dark-navy px-3 py-3 border border-light-grey hover:border-grey rounded-md'
        }
      >
        {right && <div className="mx-4">{right}</div>}
        {link && (
          <span
            className="flex justify-center align-middle text-grey normal-case dark:text-light-grey"
            style={{flex: 'fit-content'}}
          >
            {link}
          </span>
        )}
        <input
          type="url"
          className="border-none w-full focus:ring-0 p-0 normal-case bg-transparent placeholder:text-grey"
          style={{flex: 150}}
          placeholder={placeholder}
          onChange={onInputChange}
          ref={urlInput}
          value={value}
          onFocus={() => setIsFocus(true)}
          onBlur={() => setIsFocus(false)}
          disabled={disabled}
          readOnly={readOnly}
        />
      </div>
      {error && <div className="text-ruby-red py-2">{errorMessage}</div>}
    </div>
  );
};

export default LinkInput;
